<template>
  <div>
    <v-dialog v-model="show" max-width="500">
      <v-card class="buy-vr-modal">
        <v-card-title class="subheading justify-center text-xs-justify">
          <span v-if="isUserDataEmpty">Your mobile and address details need confirmation</span>
          <span v-if="!isUserDataEmpty">Your mobile and address details</span>
          <p v-if="isUserDataEmpty">
            If this information is actual, please press on the button - "Correct".
            If you want to change this information, please edit here and click on the button - "Correct" button.
          </p>
          <p v-if="!isUserDataEmpty">
            Please add the following information considered as a delivery address.
            Once added, please press on the button - "Correct".
          </p>
        </v-card-title>
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-container grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    label="Country"
                    placeholder="Country"
                    name="country"
                    data-vv-name="country"
                    v-validate="'required'"
                    :hide-details="userInfo.country.valid"
                    v-model="userInfo.country.value"
                    :error-messages="errors.collect('country')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    label="City"
                    placeholder="City"
                    name="city"
                    data-vv-name="city"
                    v-validate="'required'"
                    :hide-details="userInfo.city.valid"
                    v-model="userInfo.city.value"
                    :error-messages="errors.collect('city')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    box
                    label="Street"
                    placeholder="Street"
                    name="street"
                    data-vv-name="street"
                    v-validate="'required'"
                    :hide-details="userInfo.street.valid"
                    v-model="userInfo.street.value"
                    :error-messages="errors.collect('street')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    label="Building №"
                    placeholder="Building №"
                    name="building"
                    data-vv-name="building"
                    v-validate="'required'"
                    :hide-details="userInfo.building.valid"
                    v-model="userInfo.building.value"
                    :error-messages="errors.collect('building')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    label="Flat №"
                    placeholder="Flat №"
                    name="flat"
                    data-vv-name="flat"
                    v-validate="'required'"
                    :hide-details="userInfo.flat.valid"
                    v-model="userInfo.flat.value"
                    :error-messages="errors.collect('flat')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    label="phone"
                    placeholder="Phone"
                    name="phone"
                    data-vv-name="phone"
                    v-validate="'required'"
                    :hide-details="userInfo.phone.valid"
                    v-model="userInfo.phone.value"
                    :error-messages="errors.collect('phone')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    label="Zip code"
                    placeholder="Zip code"
                    name="zip_code"
                    data-vv-name="zip_code"
                    v-validate="'required'"
                    :hide-details="userInfo.zip_code.valid"
                    v-model="userInfo.zip_code.value"
                    :error-messages="errors.collect('zip_code')"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn dark color="purple" @click="submit">correct</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-text class="message text-xs-center">{{$t('What payment method do you prefer?')}}</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn outline color="purple" @click="showPromoModal">Stripe</v-btn>
          <v-btn color="purple" dark @click="liqPayInit">LiqPay</v-btn>
          <v-btn color="purple" dark @click="liqPayParticular">LiqPay (оплата частинами)</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isPromoModalOpen" max-width="500">
      <v-card>
        <v-card-text class="message text-xs-center">{{$t('Do you have promocodes?')}}</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn outline color="purple" @click="showNextStep">{{$t('yes')}}</v-btn>
          <v-btn color="purple" dark @click="openDefaultStripe">{{$t('no')}}</v-btn>
          <chargeBtn
            :device_id="device_id"
            :amount="stripeProps.amount"
            :currency="stripeProps.currency"
            :stripeKey="stripeProps.stripeKey"
            :promo="promocode"
            :email="email"
            ref="defaultStripe"
            style="display: none"
          ></chargeBtn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showNextModal" max-width="500">
      <v-card>
        <v-card-text class="message message-promo d-flex text-xs-center">
          <p>{{$t('Please add your promocode here and move forward')}}</p>
          <v-text-field
            v-model="promocode"
            class="input-promo"
            hide-details
            :placeholder="$t('Enter Your Promocode')"
          />
        </v-card-text>
        <v-card-actions class="justify-center">
          <chargeBtn
            :device_id="device_id"
            :amount="stripeProps.amount"
            :currency="stripeProps.currency"
            :stripeKey="stripeProps.stripeKey"
            :promo="promocode"
            :email="email"
            ref="getPromo"
            style="display: none"
          ></chargeBtn>
          <v-btn
            outline
            :disabled="!promocode.length"
            color="purple"
            @click="checkPromo"
          >{{$t('ok')}}</v-btn>
          <v-btn color="purple" dark @click="showPrevStep">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div id="liqpay_checkout"></div>
    <showModal v-model="error.show" :message="error.msg"></showModal>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import axios from "axios";
import chargeBtn from "@/components/chargeBtn";
import showModal from "@/components/ShowModal";
import { createStripeBtn } from "@/utils";

Vue.use(VeeValidate);
export default {
  name: "promoStepper",

  components: {
    chargeBtn,
    showModal
  },

  props: {
    value: Boolean,
    email: String,
    device_id: String
  },

  data: () => ({
    show: false,
    isPromoModalOpen: false,
    dialog: false,
    promocode: "",
    error: {},
    showNextModal: false,
    stripeProps: {
      amount: "",
      currency: "",
      stripeKey: ""
    },
    valid: true,
    isUserDataEmpty: true,
    userInfo: {
      phone: { value: "", valid: true },
      country: { value: "", valid: true },
      city: { value: "", valid: true },
      street: { value: "", valid: true },
      building: { value: "", valid: true },
      flat: { value: "", valid: true },
      zip_code: { value: "", valid: true }
    },
    error: {
      show: false,
      msg: "",
      btnText: ""
    },
    dictionary: {
      custom: {
        phone: {
          required: () => "Mobile input can not be empty"
        },
        country: {
          required: () => "Country input can not be empty"
        },
        city: {
          required: () => "City input can not be empty"
        },
        street: {
          required: () => "Street input can not be empty"
        },
        building: {
          required: () => "Building input can not be empty"
        },
        flat: {
          required: () => "Flat input can not be empty"
        },
        zip_code: {
          required: () => "Zip Code input can not be empty"
        }
      }
    }
  }),

  methods: {
    showPromoModal() {
      this.dialog = false;
      this.isPromoModalOpen = true;
    },

    showNextStep() {
      this.isPromoModalOpen = false;
      this.showNextModal = true;
    },

    showPrevStep() {
      this.isPromoModalOpen = true;
      this.showNextModal = false;
    },

    bind(func, context) {
      return function() {
        return func.apply(context, arguments);
      };
    },

    liqPayInit() {
      axios
        .get(this.$hostname + "/liq_pay/credentials/buy")
        .then(response => {
          console.log(response);
          return axios.post(this.$hostname + "/liq_pay/charge", {
            user_email: this.email,
            glasses_id: this.device_id,
            currency: response.data.data_currency,
            amount: response.data.data_amount,
            version: "3",
            description: `LiqPay Payment for ${this.device_id} glasses`
          });
        })
        .then(response => {
          console.log(response);
          let regExpData = /name="data"[^\"]*\"([^\"]*)\"/g;
          let regExpSignature = /name="signature"[^\"]*\"([^\"]*)\"/g;
          let data = regExpData.exec(response.data);
          let signature = regExpSignature.exec(response.data);
          let liqPayEl = document.getElementById("liqpay_checkout");
          window.LiqPayCheckoutCallback = () => {
            LiqPayCheckout.init({
              data: data[1],
              signature: signature[1],
              embedTo: "#liqpay_checkout",
              mode: "popup"
            }).on("liqpay.callback", () => {
              this.$router.push("/profile");
            });
          };
          let script = document.createElement("script");
          script.src = "//static.liqpay.ua/libjs/checkout.js";
          liqPayEl.appendChild(script);
          this.show = false;
          this.isPromoModalOpen = false;
          this.showNextModal = false;
        })
        .catch(error => {
          this.error.msg = `${this.$t(
            this.$store.getters.errorsList[error.response.data.message]
          )}`;
          this.error.show = true;
        });
    },

    liqPayParticular() {
      axios.post(this.$hostname + "/installment/create", {
        user_email: this.email
      }).then(response => {
        window.location.replace('https://payparts2.privatbank.ua/ipp/v2/payment?token=' + response.data.token)
      })
    },

    openDefaultStripe() {
      axios
        .get(this.$hostname + "/stripe/credentials/buy")
        .then(response => {
          console.log(response);
          this.stripeProps.amount = response.data.data_amount;
          this.stripeProps.currency = response.data.data_currency;
          this.stripeProps.stripeKey = response.data.data_key;
          let stripeBtn = this.$refs.defaultStripe.$el;
          stripeBtn.appendChild(createStripeBtn(response));
          this.$refs.defaultStripe.init();
          // let btn = this.$refs.getPromo.$el[1]
          setTimeout(
            this.bind(function() {
              this.$refs.defaultStripe.$el[1].click();
            }, this),
            1000
          );
          this.show = false;
          this.isPromoModalOpen = false;
          this.showNextModal = false;
        })
        .catch(error => {
          this.error.msg = `${this.$t(
            this.$store.getters.errorsList[error.response.data.message]
          )}`;
          this.error.show = true;
        });
    },

    checkPromo() {
      axios
        .get(this.$hostname + "/stripe/credentials/buy/" + this.promocode)
        .then(response => {
          console.log(response);
          this.stripeProps.amount = response.data.data_amount;
          this.stripeProps.currency = response.data.data_currency;
          this.stripeProps.stripeKey = response.data.data_key;
          let stripeBtn = this.$refs.getPromo.$el;
          stripeBtn.appendChild(createStripeBtn(response));
          this.$refs.getPromo.init();
          // let btn = this.$refs.getPromo.$el[1]
          setTimeout(
            this.bind(function() {
              this.$refs.getPromo.$el[1].click();
            }, this),
            1000
          );
        })
        .catch(error => {
          this.error.msg = `${this.$t(
            this.$store.getters.errorsList[error.response.data.message]
          )}`;
          this.error.show = true;
        });
      this.show = false;
      this.showNextModal = false;
    },

    submit() {
      for (let param in this.userInfo) {
        this.userInfo[param].valid = true;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          let formData = new FormData();
          formData.append("userEmail", this.email);
          formData.append("device_id", 'none');
          formData.append("country", this.userInfo.country.value);
          formData.append("city", this.userInfo.city.value);
          formData.append("street", this.userInfo.street.value);
          formData.append("building", this.userInfo.building.value);
          formData.append("flat", this.userInfo.flat.value);
          formData.append("zipCode", this.userInfo.zip_code.value);
          formData.append("phone", this.userInfo.phone.value);
          axios
            .post(this.$hostname + "/client/updateUserDetails",formData, {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            })
            .then(response => {
              if (response.status == 200) {
                if (this.getCurrentLang === "en") {
                  this.showPromoModal();
                } else {
                  this.dialog = true
                }
                this.show = false
              } else {
                 this.error.msg =
                  "Smth going wrong";
                this.error.btnText = "try later";
                this.error.show = true;
              }
            })
            .catch(error => {
              this.error.msg = `${
                this.$store.getters.errorsList[error.response.data.message]
              }`;
              this.error.btnText = "try later";
              this.error.show = true;
            });
        }
        this.$validator.errors.items.forEach(input => {
          this.userInfo[input.field].valid = false;
        });
      });
    },
  },

  computed: {
    getCurrentLang() {
      return localStorage.getItem("currentLang");
    }
  },

  mounted() {
    this.show = this.value;
  },

  watch: {
    value(value) {
      this.show = value;
    },

    show(value) {
      this.$emit("input", this.show);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog .v-card .v-card__actions .v-btn {
  min-width: 80px;
}

.message {
  padding-top: 20px !important;
  font-size: 17px;
}

.message-promo {
  flex-wrap: wrap;
  p {
    width: 100%;
  }
}

.input-promo {
  padding: 0;
  margin: 0;
  input {
    font-family: inherit;
    font-size: 16px !important;
  }
}
</style>